<div class="modal">
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <ng-container *ngIf="!isLoading">
    <div class="setting-widget-area">
      <div class="form-widget">
        <div class="form-title">{{currentPlanType < selectedPlan ? 'Upgrade' : 'Downgrade'}} to {{selectedPlanTitle}}</div>
        <div class="form-description">{{dealerPlanService.planDescription[this.modal.data].description}}</div>
        <div class="form-widget-area">
          <setting-payment-information [modal]="m_payment_information" (onSelectPaymentMethod)="onSelectPaymentMethod($event)" (onNoCustomerUpdate)="parseNoCustomerPaymentInfo($event)" (onHasCustomerUpdate)="parseCustomerPaymentInfo($event)"></setting-payment-information>
        </div>
      </div>
    </div>
    <div class="setting-result-area">
      <div class="close" (click)="closeModal()"><i class="material-icons">close</i></div>
      <div class="setting-result-widget">
        <div class="setting-result-title">Payment</div>
        <div class="setting-result-subtitle">{{selectedPlanTitle}}</div>
        <div class="setting-result-desciption" style="padding-bottom: 30px;margin-bottom: 30px;border-bottom: 1px solid rgba(0, 0, 0, 0.1);">{{selectedPlanFee}} / month payments</div>
        <div class="setting-result-price">
          <div>Price</div>
          <div style="text-align: right;">
            <div style="font-size: 20px;">{{selectedPlanFee}}</div>
            <div style="font-size: 12px; color: #8792A2; line-height: 18px;">*subject to change</div>
          </div>
        </div>
        <button class="primary-button" (click)="onClickUpgradePlan()" [class.disabled]="!isValidPaymentInfo">{{currentPlanType < selectedPlan ? 'Upgrade' : 'Downgrade'}} to {{selectedPlanTitle}}</button>
      </div>
    </div>
  </ng-container>
</div>
<dealer-warning [modal]="m_warning"></dealer-warning>